import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PradhanChat from "./components/PradhanChat";
import "./i18n";
import Protected from "./components/Protected";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Projects from "./pages/Projects";
import Studio from "./pages/Studio";
import GameStudio from "./pages/GameStudio";
import WebsiteStudio from "./pages/WebsiteStudio";
import Lessons from "./pages/Lessons";
import LessonDetail from "./pages/LessonDetail";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import Learn from "./pages/Learn";
import LearnWorld from "./pages/LearnWorld";
import KnowledgeGraph from "./pages/KnowledgeGraph";
import KnowledgeGraphWorld from "./pages/KnowledgeGraphWorld";
import Search from "./pages/Search";
import Adventures from "./pages/Adventures";
import AdventureDetail from "./pages/AdventureDetail";
import AdventureCertificate from "./pages/AdventureCertificate";
import AdventureWrapUp from "./pages/AdventureWrapUp";
import PublicCertificate from "./pages/PublicCertificate";
import PublicWall from "./pages/PublicWall";
import Lab from "./pages/Lab";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Gallery from "./pages/Gallery";
import GalleryDetail from "./pages/GalleryDetail";
import GitHubCallback from "./pages/GitHubCallback";
import Preview from "./pages/Preview";
import Admin from "./pages/Admin";
import AdminTestimonials from "./pages/AdminTestimonials";
import Stories from "./pages/Stories";
import Mendel from "./pages/Mendel";
import MendelLanding from "./pages/MendelLanding";
import MendelIDE from "./pages/MendelIDE";
import MendelLessons from "./pages/MendelLessons";
import MagicLink from "./pages/MagicLink";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import SubscriptionCancel from "./pages/SubscriptionCancel";
import AppsDirectory from "./pages/AppsDirectory";
import KnuthLanding from "./pages/KnuthLanding";
import KnuthDashboard from "./pages/KnuthDashboard";
import KnuthNewProject from "./pages/KnuthNewProject";
import KnuthWorkspace from "./pages/KnuthWorkspace";
import KailashLanding from "./pages/KailashLanding";
import KailashDashboard from "./pages/KailashDashboard";
import KailashNewProject from "./pages/KailashNewProject";
import KailashWorkspace from "./pages/KailashWorkspace";
import Leaderboard from "./pages/Leaderboard";
import Library from "./pages/Library";
import SchoolKits from "./pages/SchoolKits";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/games" element={<GameStudio />} />
              <Route path="/website-studio" element={<WebsiteStudio />} />
              <Route path="/lessons" element={<Lessons />} />
              <Route path="/lessons/:id" element={<LessonDetail />} />
              <Route path="/books" element={<Books />} />
              <Route path="/books/:id" element={<BookDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/gallery/:id" element={<GalleryDetail />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/github/callback" element={<GitHubCallback />} />
              <Route path="/preview/:id" element={<Preview />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/testimonials" element={<AdminTestimonials />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/apps/mendel" element={<MendelLanding />} />
              <Route path="/mendel" element={<Mendel />} />
              <Route path="/mendel/ide" element={<MendelIDE />} />
              <Route path="/mendel/ai" element={<MendelIDE />} />
              <Route path="/mendel/chromosome/:name" element={<MendelIDE />} />
              <Route path="/mendel/gene/:symbol" element={<MendelIDE />} />
              <Route path="/mendel/lessons" element={<MendelLessons />} />
              <Route path="/mendel/lessons/:slug" element={<MendelLessons />} />
              <Route path="/admin/magic" element={<MagicLink />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
              <Route path="/apps" element={<AppsDirectory />} />
              <Route path="/apps/knuth" element={<KnuthLanding />} />
              <Route path="/knuth" element={<Protected><KnuthDashboard /></Protected>} />
              <Route path="/knuth/new" element={<Protected><KnuthNewProject /></Protected>} />
              <Route path="/knuth/projects/:id" element={<Protected><KnuthWorkspace /></Protected>} />
              <Route path="/apps/kailash" element={<KailashLanding />} />
              <Route path="/kailash" element={<Protected><KailashDashboard /></Protected>} />
              <Route path="/kailash/new" element={<Protected><KailashNewProject /></Protected>} />
              <Route path="/kailash/projects/:id" element={<Protected><KailashWorkspace /></Protected>} />
              <Route path="/journey" element={<Navigate to="/library" replace />} />
              <Route path="/journey/:slug" element={<Navigate to="/library" replace />} />
              <Route path="/characters" element={<Navigate to="/" replace />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/library" element={<Library />} />
              <Route path="/library/:slug" element={<Library />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/learn/graph" element={<KnowledgeGraph />} />
              <Route path="/learn/graph/:world" element={<KnowledgeGraphWorld />} />
              <Route path="/learn/:world" element={<LearnWorld />} />
              <Route path="/adventures" element={<Adventures />} />
              <Route path="/adventures/:slug" element={<AdventureDetail />} />
              <Route path="/adventures/:slug/certificate" element={<AdventureCertificate />} />
              <Route path="/adventures/wrap-up" element={<AdventureWrapUp />} />
              <Route path="/c/:token" element={<PublicCertificate />} />
              <Route path="/wall/:identifier" element={<PublicWall />} />
              <Route path="/search" element={<Search />} />
              <Route path="/lab" element={<Lab />} />
              <Route path="/school-kits" element={<SchoolKits />} />
            </Routes>
          </main>
          <Footer />
          <PradhanChat />
          <Toaster
            position="top-center"
            richColors
            offset="80px"
            toastOptions={{ style: { zIndex: 60 } }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
